export default "__VITE_ASSET__DxYHjQ35__"